import React from 'react';

const SectionCashbackshops = ({
}) => {

  return (
    <section id="cashback_shops">
      <div className="mb-0">
        <div className="d-flex bg-tunagate-gradation p-3 align-items-center justify-content-center" style={{ fontWeight: "bold" }}>
          <a
            href="https://tunagate.com/tunacodes/shops"
            target="_blank"
          >
            <p className="cp-0 m-0 text-white text-left border-0 text-fz-11px" style={{ width: "90%" }}>
            イベント日に提携店舗に行くと参加者は500円キャッシュバック！ クリエイターにもPRチケット1,000円相当プレゼント！
            </p>
          </a>
          <span className="text-center" style={{ width: "10%" }}>
            <img src="/assets2019/img/icon_linknext.svg" className="" height="auto" style={{ width: "15px" }} />
          </span>
        </div>
      </div>
    </section>
  );
};

export default SectionCashbackshops
;
